@import '../../themes/capsule.globals';

:host {
  --outer-container-padding-start: 8px;
  --outer-container-padding-end: 8px;
  --outer-container-padding-top: 8px;
  --outer-container-padding-bottom: 8px;

  --container-background-color: var(--cpsl-color-select-surface-default);
  --container-hover-background-color: var(--cpsl-color-select-surface-hover);
  --container-border-radius: calc(var(--cpsl-border-radius-select) - 4px);
  --container-padding-start: 8px;
  --container-padding-end: 8px;
  --container-padding-top: 8px;
  --container-padding-bottom: 8px;

  display: block;
  font-family: $font-family-base;
  color: var(--cpsl-color-text-primary);
  cursor: pointer;
}

.inner-container {
  @include padding(
    var(--container-padding-top),
    var(--container-padding-end),
    var(--container-padding-bottom),
    var(--container-padding-start)
  );

  background-color: var(--container-background-color);

  border-radius: var(--container-border-radius);
  height: 100%;
  display: flex;
  align-items: center;
}

.outer-container {
  @include padding(
    var(--outer-container-padding-top),
    var(--outer-container-padding-end),
    var(--outer-container-padding-bottom),
    var(--outer-container-padding-start)
  );

  background-color: var(--container-background-color);

  &:hover {
    & > .inner-container {
      background-color: var(--container-hover-background-color);
    }
  }
}

.selected {
  background-color: var(--container-hover-background-color);
}

:host(.in-select-box) {
  --container-background-color: transparent;
  --container-hover-background-color: transparent;
  --container-border-width: 0px;
  --container-padding-start: 0px;
  --container-padding-end: 0px;
  --container-padding-top: 0px;
  --container-padding-bottom: 0px;
  flex: 1;
  height: 100%;
}
